import {
  createdByUserUuid,
  softDelete,
  timestamps,
  uuid,
} from '@snap-types/models/common';
import { z } from 'zod/v4';

import { snapQuoteStatusSchema } from './enums';

export const columns = {
  uuid,
  status: snapQuoteStatusSchema,
  quoteId: z.string(),

  customerUuid: uuid.nullish(),
  siteUuid: uuid,

  ...createdByUserUuid,
  ...softDelete,
  ...timestamps,
};
